export default "__VITE_PUBLIC_ASSET__f78b719c__"